import {
  getPrizeTable,
  getPurse,
  getTournamentType,
  isRoundNumber456,
} from "@/utils/tournaments";
import {
  AGGREGATE_CTP,
  AGGREGATE_CTP_FINALE,
  AGGREGATE_CTP_4_5_6_ROUNDS,
  BIRDIE_STREAK,
  BIRDIE_STREAK_4_5_6_ROUNDS,
  LONGEST_DRIVE,
  LONGEST_DRIVE_4_5_6_ROUNDS,
  MOST_GIRS,
  SOCIAL_MEDIA,
} from "@/utils/constants";
import CalculatePrize from "./CalculatePrize";
import PurseCard from "./PurseCard";
import FullPrizeList from "./FullPrizeList";

interface PurseSeason2Props {
  playersCount: number;
  tournamentName: string;
  tournamentId: string;
  inputVal: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const PurseSeason2 = ({
  playersCount,
  tournamentName,
  tournamentId,
  inputVal,
  handleInputChange,
}: PurseSeason2Props) => {
  const type = getTournamentType(2, tournamentId, tournamentName);
  const isRound456 = isRoundNumber456(tournamentName);

  const aggregateCtpPrizes = () => {
    if (isRound456) {
      return AGGREGATE_CTP_4_5_6_ROUNDS;
    }

    if (type.isFinalSeason2) {
      return AGGREGATE_CTP_FINALE;
    }
    return AGGREGATE_CTP;
  };

  const birdieStreakPrizes = () => {
    if (isRound456) {
      return BIRDIE_STREAK_4_5_6_ROUNDS;
    }
    return BIRDIE_STREAK;
  };

  const longestDrivePrizes = () => {
    if (isRound456) {
      return LONGEST_DRIVE_4_5_6_ROUNDS;
    }
    return LONGEST_DRIVE;
  };

  const prizeList = getPrizeTable(
    2,
    tournamentId,
    tournamentName,
    playersCount
  );

  return (
    <div className="flex justify-center">
      <div className="w-full min-[1041px]:!max-w-[965px]">
        <ul className="flex flex-col md:flex-row gap-5 md:gap-36 lg:gap-40 xl:gap-48 p-0 w-full list-none mb-[50px]">
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">
              $
              {getPurse(
                2,
                tournamentId,
                tournamentName,
                playersCount
              ).toLocaleString("en-US")}
            </span>
            <span className="text-xl text-tm-c-gray-300">Purse</span>
          </li>
          <li className="flex flex-col gap-2.5">
            <span className="text-4xl 2xl:text-6xl">
              {type.isFinalSeason2 ? 100 : playersCount}
            </span>
            <span className="text-xl text-tm-c-gray-300">Players</span>
          </li>
        </ul>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-5 2xl:gap-[30px]">
          <CalculatePrize
            prizeList={prizeList}
            inputVal={inputVal}
            handleInputChange={handleInputChange}
          />
          <PurseCard
            title="Stroke play"
            prizeList={Array.from({ length: 5 }, (_, i) => prizeList[i] ?? 0)}
          />
          <PurseCard title="Aggregate CTP" prizeList={aggregateCtpPrizes()} />
          {!type.isFinalSeason2 && (
            <>
              <PurseCard
                title="Birdie Streak"
                prizeList={birdieStreakPrizes()}
              />
              <PurseCard
                title="Longest Drive - Men"
                prizeList={longestDrivePrizes()}
              />
              <PurseCard
                title="Longest Drive - Women"
                prizeList={longestDrivePrizes()}
              />
            </>
          )}
          {!type.isFinalSeason2 && !isRound456 && (
            <PurseCard title="Most GIRs" prizeList={MOST_GIRS} />
          )}
          {!type.isFinalSeason2 && (
            <div
              className={`flex flex-col gap-2.5 lg:gap-7.5 min-h-[165px] p-5 lg:p-7.5
                rounded-[10px] bg-tm-c-gray-950 border border-tm-c-gray-700
                lg:min-h-[200px] lg:py-6 lg:px-[30px]
                min-[1041px]:!min-h-[300px]
              `}
            >
              <span className="text-xs md:text-base text-left">
                Social Media
              </span>
              <ul className="text-base lg:text-xl my-2.5 mx-0 w-full list-none p-0 [&>li]:flex [&>li]:w-full [&>li]:justify-between">
                <li>
                  <span>2x</span>
                  <span className="font-medium">${SOCIAL_MEDIA[0]}</span>
                </li>
                <span className="flex w-full h-[1px] bg-tm-c-gray-800 my-2" />
                <li>
                  <span>2x</span>
                  <span className="font-medium">${SOCIAL_MEDIA[1]}</span>
                </li>
              </ul>
            </div>
          )}
        </div>
        <FullPrizeList />
      </div>
    </div>
  );
};

export default PurseSeason2;
